<template>
    <div class="login" :class="{login:!isMobile,mLogin:isMobile,mobileCommon:isMobile}">
        <topLogo v-if="!is_dialog" style="background-color: transparent"></topLogo>
        <div class="box" v-loading="loading">
            <h3>{{ langPage['compte-popup-inscription']['TXT_seconnecter'] }}</h3>
            <el-form :rules="formRules" label-position="top" ref="form" :model="formdata">
                <el-form-item :label="langPage['compte-identification']['TXT_email']" prop="email">
                    <el-input class="input" v-model="formdata.email"></el-input>
                </el-form-item>
                <el-form-item class="passwordFormItem" :label="langPage['compte-identification']['TXT_motdepasse']" required>
                    <el-input class="input" v-model="formdata.password" show-password></el-input>
                </el-form-item>
                <el-form-item>
                    <el-row type="flex" align="middle">
                        <el-checkbox v-model="remember" v-if="$store.state.cookieSaveType!=='base'" class="remember">
                            {{ langPage['compte-identification']['TXT_souvenirmoi'] }}
                        </el-checkbox>
                        <div class="resetPswLink"><span></span>
                            <router-link to="/resetPassword">{{ langPage['compte-oublie']['TXT_mdpoublie'] }}
                            </router-link>
                        </div>
                    </el-row>
                </el-form-item>
                <div class="submit" @click="sub">{{ langPage['compte-identification']['TXT_connexion'] }}</div>
            </el-form>
            <!--            <el-form :rules="formRules"  label-position="top" ref="form"  :model="formdata">-->
            <!--                <el-form-item :label="email" prop="email">-->
            <!--                    <el-input class="input" v-model="formdata.email"></el-input>-->
            <!--                 </el-form-item>-->
            <!--                <el-form-item :label="password" required>-->
            <!--                    <el-input class="input" v-model="formdata.password" show-password></el-input>-->
            <!--                </el-form-item>-->
            <!--                <div class="submit" @click="sub">ddd</div>-->
            <!--            </el-form>-->
            <div class="signLink"><span>{{ langPage['v4-inscription-acheteur']['TXT_pasdecompte'] + '&nbsp;' }}</span>
                <router-link to="/sign">{{ langPage['v4-menu-not-connected']['TXT_sinscrire'] }}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import topLogo from "@/components/topLogo";

let loginHelper = require('@/utils/helper/Login/login_helper');
export default {
    name: "login",
    components: {topLogo},
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            formdata: {
                email: '',
                password: '',
            },
            remember: '',
            formRules: {
                email: [
                    {
                        required: true,
                        message: this.$store.state.langPage['compte-inscription']['TJS_veuillezsaisiremail'],
                        trigger: 'blur'
                    },
                    {
                        type: 'email',
                        message: this.$store.state.langPage['compte-inscription']['TJS_veuillezsaisiremailvalide'],
                        trigger: ['blur']
                    }
                ],
            },
            loading: false
        }
    },
    props: {
        is_dialog: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        langPage() {
            return this.$store.state.langPage
        }
    },
    methods: {
        sub() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    if (this.remember) {
                        this.setCookie(this.formdata.email, this.formdata.password, 30);
                    } else {
                        this.clearCookie()
                    }
                    this.loading = true;
                    this.$api.auth.buyerLogin(this.formdata).then(res => {
                        this.loading = false;
                        if (res.code !== 0) {
                            return this.$message.error(res.message);
                        }
                        let data = res.data;
                        loginHelper.afterLogin(this, data);
                    })
                } else {
                    return false;
                }
            })
        },
        setCookie(c_name, c_pwd, exdays) {
            var exdate = new Date(); //获取时间
            exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
            //字符串拼接cookie
            window.document.cookie =
                "efashion_email" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
            window.document.cookie =
                "efashion_password" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
        },
        getCookie: function () {
            if (document.cookie.length > 0) {
                var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
                for (var i = 0; i < arr.length; i++) {
                    var arr2 = arr[i].split("="); //再次切割
                    //判断查找相对应的值
                    if (arr2[0] == "efashion_email") {
                        this.formdata.email = arr2[1]; //保存到保存数据的地方
                    } else if (arr2[0] == "efashion_password") {
                        this.formdata.password = arr2[1];
                    }
                }
            }
        },
        clearCookie: function () {
            this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
        },
    },
    mounted() {
        this.getCookie()
    }
}
</script>

<style lang="less" scoped src="@/assets/viewCss/views/Login.less">
</style>
